import { createContext } from 'react';
const TrackingContext = /*#__PURE__*/createContext(undefined);
export default TrackingContext;